import type { FunctionComponent } from "react";

import type { Edition } from "shared/lib/edition";

import type { AppBarVariant } from "scmp-app/components/app-bar/types";
import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";

import { StyledHeaderOnelineMenuContainer } from "./styles";

export type HeaderFeaturesOneLineMenuProps = HeaderFeatureCommonProps & {
  appBarVariant?: AppBarVariant;
  initEdition?: Edition;
  isShowFullList?: boolean;
  isShowPrefixHyphen?: boolean;
};

export const HeaderFeaturesOneLineMenu: FunctionComponent<HeaderFeaturesOneLineMenuProps> = ({
  appBarVariant,
  initEdition,
  isShowFullList,
  isShowPrefixHyphen,
  ...props
}) => (
  <StyledHeaderOnelineMenuContainer
    $isShowFullList={isShowFullList}
    appBarVariant={appBarVariant}
    initEdition={initEdition}
    isShowFullList={isShowFullList}
    isShowPrefixHyphen={isShowPrefixHyphen}
    {...getResponsiveProps(props)}
  />
);

HeaderFeaturesOneLineMenu.displayName = "HeaderFeaturesOneLineMenu";
